

<!-- Brand Logo -->
<a class="brand-link brand-text" style="background:#4f226c;height:50px;">
    <span id="logo-plataforma" class="logo-lg">
        <img height="55" src="assets/img/logo-mensajero.png" style="display:block;margin:auto;margin-top: -5%;">
    </span>
</a>
